import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import { NumberToLetter } from 'convertir-nombre-lettre';

export default {
    name: 'view-facture',
    components: {
        EnteteBonEtFacture
    },
    props: [],
    data() {
        return {
            is_printing: false,
            info_is_loading: true,
            info_error_load: false,
            est_assure: false,

            is_printable: false,

            total_net: 0,
            filename: '',
            montant_en_lettre: '',
            can_print: false
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        selected_insurance_bill() {
            return this.$store.getters['selected_insurance_bill'];
        },
    },

    mounted() {
        this.calculateBill()

        const tmpstamp = this.current_date.getTime()
        this.filename = 'Facture de remboursement_'+tmpstamp
    },

    methods: {
        calculateBill() {
            this.total_net = 0

            this.selected_insurance_bill.operations.forEach((operation) => {
                let montant = 0
                montant = operation.part_assureur

                this.total_net += montant
            });
            this.montant_en_lettre = NumberToLetter(this.total_net)
        },

        printAssurBill() {
            this.can_print = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
            }, 500);
        }
    }
}